
import { defineComponent } from "vue";
import DefaultComponent from "./default.vue";
import Visualizer from "../ssa_components/visualizer/index.vue";
import PickTable from "../ssa_components/visualizer/pickTable.vue";
import Hierarchy from "../ssa_components/hierarchy/index.vue";
import DisplayPane from "../ssa_components/displayPane/index.vue";
import Handle from "./handle.vue";
import { useLayoutStore } from "@/stores/layoutStore";

export default defineComponent({
	setup() {
		const layoutStore = useLayoutStore();
		return { layoutStore };
	},
	name: "LayoutComponent",
	props: {
		children: {
			type: Array,
			default: () => []
		},
		id: {
			type: Number,
			default: null
		},
		componentName: {
			type: String,
			default: ""
		},
		stacked: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: ""
		},
		component: {
			type: String,
			default: "LayoutComponent"
		},
		componentState: {
			type: Object,
			default: () => {
				return { flex: 1, color: "#fff" };
			}
		}
	},
	computed: {
		panelLayout() {
			return this.layoutStore.panelLayout;
		}
	},
	components: {
		DefaultComponent,
		Visualizer,
		PickTable,
		Hierarchy,
		DisplayPane,
		Handle
	}
});
